import {generateMethod, url} from 'shared/javascripts/api';

const PREFIX_URL = `${window.APP.apiURL}/_exclusive/prakerja`;
const PREFIX_COUPON_DEALS_URL = `${window.APP.apiURL}/coupon-deals`;
const NEO_PREFIX_URL = `${window.APP.apiURL}/_exclusive/neo`;
const INFO_PREFIX_URL = `${window.APP.apiURL}/info`;
const INVOICE_PREFIX_URL = `${window.APP.apiURL}/invoices`;

let mockInterfaces = {};

const interfaces = window.API.wrap(
  {
    getNeoConfig: generateMethod({
      prefix: NEO_PREFIX_URL,
      address: url`configs`,
      scope: 'user',
      method: 'post',
    }),
    getNeoToggles: generateMethod({
      prefix: NEO_PREFIX_URL,
      address: url`toggles`,
      scope: 'user',
      method: 'post',
    }),
    getDynamicSection: generateMethod({
      prefix: PREFIX_COUPON_DEALS_URL,
      address: url`sections`,
      scope: 'user',
      method: 'get',
    }),
    getMerchants: generateMethod({
      prefix: PREFIX_COUPON_DEALS_URL,
      address: url`merchants`,
      scope: 'user',
      method: 'get',
    }),
    getMerchantDetail: generateMethod({
      address: url`merchants/${'id'}`,
      prefix: PREFIX_COUPON_DEALS_URL,
      scope: 'user',
      method: 'get',
    }),
    getBanners: generateMethod({
      address: url`banners`,
      prefix: `${window.APP.apiURL}`,
      scope: 'user',
      method: 'get',
    }),
    getDeals: generateMethod({
      address: '',
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getBestCourses: generateMethod({
      address: 'skus/best-packages',
      prefix: PREFIX_COUPON_DEALS_URL,
      scope: 'user',
      method: 'get',
    }),
    getCategories: generateMethod({
      address: url`categories`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getReviews: generateMethod({
      address: url`reviews`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getCourses: generateMethod({
      address: url`courses`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getCourseDetail: generateMethod({
      address: url`courses/${'id'}`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getCapacity: generateMethod({
      address: url`courses/${'id'}/capacity`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getAddress: generateMethod({
      address: url`addresses`,
      prefix: INFO_PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    createTransaction: generateMethod({
      address: url`transactions`,
      prefix: PREFIX_COUPON_DEALS_URL,
      scope: 'user',
      method: 'post',
    }),
    createInvoice: generateMethod({
      address: '',
      prefix: INVOICE_PREFIX_URL,
      scope: 'user',
      method: 'post',
    }),
    getPrakerjaTransactions: generateMethod({
      address: 'transactions',
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getCouponDealsTransaction: generateMethod({
      address: url`transactions/${'id'}`,
      prefix: PREFIX_COUPON_DEALS_URL,
      scope: 'user',
      method: 'get',
    }),
    getPrakerjaTransactionDetail: generateMethod({
      address: url`transactions/${'id'}`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getInvoice: generateMethod({
      address: url`${'id'}`,
      prefix: INVOICE_PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getPaymentMethods: generateMethod({
      address: url`payment-methods/groups`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    feeCalculation: generateMethod({
      address: url`payment-methods/fee-calculations`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'post',
    }),
    createPurchaseInvoice: generateMethod({
      address: url`transactions/${'id'}/invoices`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'post',
    }),
    ...mockInterfaces,
  },
  'xhrPublicEduKarier'
);

export default interfaces;
